import React from "react";

function Loading() {
  return <div style={{ padding: "10px" }}>Loading</div>;
}

export default Loading;
